<template>
  <div class="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
    <div class="bg-white rounded-xl shadow-xl p-8 w-full max-w-md">
      <h2 class="text-xl font-semibold mb-4">{{ title }}</h2>
      <p class="text-sm text-gray-600 mb-6">{{ message }}</p>
      <div class="flex gap-3 justify-end">
        <button
          class="px-4 py-2 rounded-lg border border-gray-300 hover:bg-gray-50 transition-colors text-sm"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
        <button
          :class="confirmClass || 'bg-blue-600 hover:bg-blue-700'"
          class="px-4 py-2 rounded-lg text-white transition-colors text-sm"
          @click="$emit('confirm')"
        >
          {{ confirmLabel || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OAuthConfirmDialog',
  emits: ['confirm', 'cancel'],
  props: {
    title: { type: String, required: true },
    message: { type: String, required: true },
    confirmLabel: { type: String, default: 'Confirm' },
    confirmClass: { type: String, default: '' },
  },
};
</script>
